export default __webpack_public_path__ + "static/media/EC.580b7ca5.png";